import React from "react";
import ventLogo from "@/assets/vent-logo.svg";

interface VentLogoProps {
  className?: string;
  showAnimation?: boolean;
}

export const VentLogo: React.FC<VentLogoProps> = ({ className = "", showAnimation = false }) => {
  return (
    <div className={`relative bg-transparent ${className}`}>
      <img 
        src={ventLogo} 
        alt="Vent Logo" 
        className="h-14 w-auto dark:invert"
      />
      {showAnimation && (
        <>
          {/* Air particles */}
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-primary-glow rounded-full animate-fade-in opacity-0"
              style={{
                left: `${35 + Math.random() * 20}px`,
                top: `${8 + i * 3}px`,
                animationDelay: `${i * 0.1}s`,
                animationDuration: '2s',
                animationIterationCount: '3',
                animationName: 'airFlow'
              }}
            />
          ))}
          {/* Wind lines */}
          {[...Array(4)].map((_, i) => (
            <div
              key={`line-${i}`}
              className="absolute h-px bg-gradient-to-r from-primary-glow to-transparent animate-fade-in opacity-0"
              style={{
                left: '35px',
                top: `${10 + i * 5}px`,
                width: `${20 + i * 5}px`,
                animationDelay: `${0.5 + i * 0.2}s`,
                animationDuration: '1.5s',
                animationIterationCount: '2'
              }}
            />
          ))}
        </>
      )}
    </div>
  );
};